import { Schedule } from '@root/globalTypes';
import {
  DisplayOption,
  DisplayOptionsSettingsEndpoint,
} from '@services/resources/users/displayOptions/types';
import {
  getDisplayOptionsSettings,
  getWorkloadDisplayOptionsSettingsEndpoint,
} from '@components/workload/drawer/displayOptions/helpers';
import { parseProjectTitleWithAddress } from '@utils/textHelpers';

export const getJobSubtitle = (schedule?: Schedule) => {
  const job = schedule?.task?.job;

  return parseProjectTitleWithAddress(job?.project);
};

const WEEKEND_ENDPOINTS: DisplayOptionsSettingsEndpoint[] = [
  'weekCalendar',
  'twoWeekCalendar',
  'monthCalendar',
];

export const getSkipWeekendDefaults = (displayOptions: DisplayOption[], calendarType?: string) => {
  const current = getWorkloadDisplayOptionsSettingsEndpoint(calendarType);
  const settings = [current, ...WEEKEND_ENDPOINTS.filter((el) => el !== current)]
    .map((endpoint) => getDisplayOptionsSettings(displayOptions, endpoint))
    .find(
      (el) => typeof el.weekendsSaturday === 'boolean' || typeof el.weekendsSunday === 'boolean',
    );

  return {
    skipSaturday: settings?.weekendsSaturday === false,
    skipSunday: settings?.weekendsSunday === false,
  };
};

export const scrollActiveScheduleIntoView = (container: HTMLElement) => {
  const element = container.querySelector<HTMLElement>('.scheduler-active-schedule');
  if (!element) return;

  const stickyHeight = container.querySelector<HTMLElement>('.sticky')?.offsetHeight || 0;
  const containerRect = container.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const visibleTop = containerRect.top + stickyHeight;
  if (elementRect.top >= visibleTop && elementRect.bottom <= containerRect.bottom) return;

  const visibleHeight = container.clientHeight - stickyHeight;
  container.scrollTop += elementRect.top - visibleTop - (visibleHeight - elementRect.height) / 2;
};
